import styled, { keyframes } from "styled-components";
import { DownOutlined } from "@ant-design/icons";

// Container styling changes based on the "separate" prop.
export const Container = styled.div<{ separate?: boolean }>`
  position: relative;
  display: inline-flex;
  border: ${({ separate }) => (separate ? 'none' : '1px solid rgba(228, 215, 205, 1)')};
  border-radius: ${({ separate }) => (separate ? '0' : '6px')};
  gap: ${({ separate }) => (separate ? '4px' : '0')};
  overflow: visible;
  
  font-size: 12px;
  color: rgba(57, 29, 10, 1);
`;

export const DropdownWrapper = styled.div<{ separate?: boolean }>`
  position: relative;

  ${({ separate }) => !separate && `
    &:last-child > div:first-child {
      border-radius: 0 6px 6px 0;
    }
    &:first-child > div:first-child {
      border-radius: 6px 0 0 6px;
    }
  `}
`;

export const Selector = styled.div<{ separate?: boolean }>`
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  background: #fff;
  transition: background 0.2s ease;
  height: 37px;
  border: ${({ separate }) => (separate ? '1px solid rgba(228, 215, 205, 1)' : 'none')};
  border-radius: ${({ separate }) => (separate ? '6px' : '0')};
  min-width: ${({ separate }) => (separate ? '80px' : '0')};
  &:hover {
    background: #f0f0f0;
  }
`;

export const YearInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  font: inherit;
  outline: none;


  font-size: 12px;
  color: rgba(57, 29, 10, 1);
  line-height: 1.5714285714285714;
`;

// Animation for dropdown options
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Options container for dropdown items.
export const Options = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(255, 251, 248, 1);
  border: 1px solid rgba(198, 166, 145, 1);
  border-radius: 0 0 6px 6px;
  max-height: 150px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* smooth/native feel on iOS */
  overscroll-behavior: contain;      /* prevent scroll chaining */
  animation: ${fadeIn} 0.3s ease-out;
  z-index: 100;

  /* Custom scrollbar styling (WebKit-based browsers) */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

// Each dropdown option
export const Option = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #f9f9f9;
  }
`;

// Arrow icon rotates based on whether the dropdown is open.
export const ArrowIcon = styled(DownOutlined)<{ open: boolean }>`
  transition: transform 0.2s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;


export const Label = styled.label`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: #89796E;
`
